var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"edit-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_c('pvd-icon',{staticClass:"m-small-right",attrs:{"icon":"edit","aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.isNotIstock === 'true'? _vm.pd_content.edit_link_label : _vm.pd_content.edit_link)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }